import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { CoverageZonesApiAdapter } from '../adapters/CoverageZonesApiAdapter';
import { CountryModel } from '../models/Country';

export const useCountries = () => {
    const httpClient = createHttpClient(apiClientWH);
    const apiAdapter = new CoverageZonesApiAdapter(httpClient);

    const { data, isLoading, error, isPending } = useQuery<CountryModel[]>({
        queryKey: ['countries'],
        queryFn: () => apiAdapter.getCountries(),
        staleTime: Infinity, // No cambian frecuentemente
        gcTime: 1000 * 60 * 60, // 1 hora
    });

    return {
        countries: data ?? [],
        isLoading: isLoading || isPending,
        error,
        total: data?.length ?? 0,
    };
};


